module.exports = __webpack_public_path__ + "public/images/slider/potapov.522258a5bb8e438337e38a54569597bc.webp";